import { Text } from "@mantine/core";

export const textComponentSettings = Text.extend({
  defaultProps: {
    color: "gray.7",
  },
});
